type ReplacementConfirmPopoverProps = {
  zoneName: string;
  fromBonusLabel: string;
  toBonusLabel: string;
  isSubmitting?: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

export function ReplacementConfirmPopover({
  zoneName,
  fromBonusLabel,
  toBonusLabel,
  isSubmitting = false,
  onCancel,
  onConfirm
}: ReplacementConfirmPopoverProps) {
  return (
    <div className="resource-replacement-popover" role="alertdialog" aria-live="polite">
      <div className="resource-replacement-popover__message">
        <strong>{zoneName}</strong> is currently assigned to <strong>{fromBonusLabel}</strong>. Move it to <strong>{toBonusLabel}</strong>?
      </div>
      <div className="resource-replacement-popover__actions">
        <button className="btn btn-sm btn-outline-light" type="button" disabled={isSubmitting} onClick={onCancel}>
          Cancel
        </button>
        <button className="btn btn-sm btn-primary" type="button" disabled={isSubmitting} onClick={onConfirm}>
          Move zone
        </button>
      </div>
    </div>
  );
}
